// tslint:disable
export var TransmissionType;
(function (TransmissionType) {
    // INB
    TransmissionType[TransmissionType["INB"] = 1] = "INB";
    // OUTB
    TransmissionType[TransmissionType["OUTB"] = 2] = "OUTB";
})(TransmissionType || (TransmissionType = {}));
//# sourceMappingURL=TransmissionType.js.map